// capture/overlayConfig.js

export const OVERLAY_STATE = {
  SEARCHING: { stroke: "#94a3b8", dash: "8 8", hint: "Position your face in the oval" },
  ALIGNING:  { stroke: "#f59e0b", dash: "none", hint: null },  // hint comes from direction
  HOLDING:   { stroke: "#22c55e", dash: "none", hint: "Hold still…" },
  CAPTURED:  { stroke: "#ffffff", dash: "none", hint: "✓" },
};

/**
 * Sign conventions:
 * Yaw Positive (+)  = LEFT
 * Yaw Negative (−)  = RIGHT
 * Pitch Positive (+) = UP
 * Pitch Negative (−) = DOWN
 */
export const POSE_RULES = {
  Pose_Variation_A: {
    1: { label: "UP",    pMin: 12,  pMax: 35,  yMin: -15, yMax: 15 },
    2: { label: "DOWN",  pMin: -35, pMax: -12, yMin: -15, yMax: 15 },
    3: { label: "LEFT",  pMin: -15, pMax: 15,  yMin: 15,  yMax: 40 },
    4: { label: "RIGHT", pMin: -15, pMax: 15,  yMin: -40, yMax: -15 },
  },
  Pose_Variation_B: {
    5: { label: "UP-LEFT",    pMin: 15,  pMax: 25,  yMin: 20,  yMax: 35 },
    6: { label: "UP-RIGHT",   pMin: 15,  pMax: 25,  yMin: -35, yMax: -20 },
    7: { label: "DOWN-LEFT",  pMin: -25, pMax: -15, yMin: 20,  yMax: 35 },
    8: { label: "DOWN-RIGHT", pMin: -25, pMax: -15, yMin: -35, yMax: -20 },
  }
};

export const POSE_TARGETS = {
  1: [20, 0],     // UP: pitch +20, yaw 0
  2: [-20, 0],    // DOWN: pitch -20, yaw 0
  3: [0, 25],     // LEFT: pitch 0, yaw +25
  4: [0, -25],    // RIGHT: pitch 0, yaw -25
  5: [20, 27],    // UP-LEFT: pitch +20, yaw +27
  6: [20, -27],   // UP-RIGHT: pitch +20, yaw -27
  7: [-20, 27],   // DOWN-LEFT: pitch -20, yaw +27
  8: [-20, -27],  // DOWN-RIGHT: pitch -20, yaw -27
};

export const SELFIE_PROMPTS = [
  { step: 1, text: "Neutral expression. Look straight ahead.", noGlasses: false },
  { step: 2, text: "Change of clothing. Neutral expression.", noGlasses: false },
  { step: 3, text: "Change of hairstyle or lighting. Neutral.", noGlasses: false },
  { step: 4, text: "First neutral capture (please remove glasses).", noGlasses: true },
  { step: 5, text: "Change of clothing, neutral expression (no glasses).", noGlasses: true },
  { step: 6, text: "Change of expression (slight smile, no glasses).", noGlasses: true }
];
